module.exports = __webpack_public_path__ + "media/images/lp_team-bg-c98687a67c4b4cf36222a23615793dc5.webp";